import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import {
  Container,
  Title,
  DataList,
  Data,
  TesterName,
  AnswerOtherResponse,
} from './styles';

const OtherWritten = (props) => {
  const {
    others,
  } = props;

  if (others === null || _.isEmpty(others)) {
    return null;
  }

  return (
    <Container>
      <Title>
        Other - Written Response
      </Title>

      <DataList>
        {others.map((other) => (
          <Data>
            <TesterName>{other?.firstName}</TesterName>
            <AnswerOtherResponse>{other?.valueText}</AnswerOtherResponse>
          </Data>
        ))}
      </DataList>
    </Container>
  );
};

OtherWritten.propTypes = {
  others: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default OtherWritten;
